module.exports = __webpack_public_path__ + "static/home-bg-2ba2529b2df483cdc3d379fb2882a2a9.jpg";